import type {
  MealPlanEndedByName,
  MealRenewalReason,
  WorkoutRenewalReason,
} from '@steado/admin-contract/user-detail';

/**
 * Why a track does not renew, and how a meal plan stopped, in words.
 *
 * Exhaustive `Record`s with no fallback branch, for the reason `plan-tone.ts`
 * gives: each vocabulary is a closed `z.enum`, so a member this build has
 * never heard of fails the response parse rather than arriving here to be
 * printed as a slug — and adding one upstream is a compile error here instead
 * of raw wire text on the screen.
 */
export const WORKOUT_RENEWAL_LABELS: Readonly<Record<WorkoutRenewalReason, string>> = {
  gym_coached: 'their trainer plans it',
  nothing_to_plan: 'nothing to plan',
  dormant: 'no recent activity',
  lapsed: 'past the grace period',
  not_due: 'still running',
  asked_today: 'asked for one today',
};

export const MEAL_RENEWAL_LABELS: Readonly<Record<MealRenewalReason, string>> = {
  gym_coached: 'their trainer plans it',
  not_premium: 'not premium',
  never_made: 'never made one',
  in_flight: 'one is generating',
  failed: 'the last one failed',
  ended_by_user: 'they ended it',
  dormant: 'no recent activity',
  not_due: 'still running',
  lapsed: 'past the grace period',
};

export const MEAL_PLAN_ENDED_BY_LABELS: Readonly<Record<MealPlanEndedByName, string>> = {
  user: 'they ended it',
  expired: 'it ran out',
};
